import { Component, OnInit, Input } from '@angular/core';
import { PlayerClass } from '../player';
import {PlayerService} from '../player.service';

@Component({
  selector: 'app-players',
  templateUrl: './players.component.html',
  styleUrls: ['./players.component.css']
})

export class PlayersComponent implements OnInit {
  @Input('firstScreen') firstScreen : any = true;
  constructor(public playerservice : PlayerService) { }

  ngOnInit() {
    this.playerservice.getPlayers();
  }

}



// WEBPACK FOOTER //
// C:/Users/BHAJ/Desktop/dribbler/src/app/players/players.component.ts